import { useRef } from 'react';

import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { Button, DropdownMenu, DropdownMenuItem } from '@bringg/react-components';

import styles from './actions-menu.module.scss';

interface Props {
	items: DropdownMenuItem[];
	setIsLoading?: boolean;
	onSelect: (rowId: number | string) => void;
	isLoading?: boolean;
}

const ActionsMenu = ({ items, onSelect, isLoading }: Props) => {
	const buttonRef = useRef<HTMLDivElement>(null);

	return (
		<div ref={buttonRef}>
			{isLoading ? (
				<BringgIcon iconName={BringgFontIcons.Loader} spin />
			) : (
				<DropdownMenu
					items={items}
					placement="bottom-end"
					offset={[16, -1]}
					noArrow={false}
					trigger={['click']}
					destroyOnHide
					getPopupContainer={() => buttonRef.current}
					onMenuSelect={onSelect}
				>
					<Button
						className={styles.menuButton}
						type="link"
						icon={<BringgIcon iconName={BringgFontIcons.MenuHorizontal} className={styles.menuIcon} />}
						data-test-id="action-menu-button"
						aria-label="action-menu-button"
					/>
				</DropdownMenu>
			)}
		</div>
	);
};

export default ActionsMenu;
